<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-header-menu-platform" v-bind:class="{'selected': isSelected}" v-if="enableFilter">
      <el-dropdown 
        class="wy-header-manu-dropdown" 
        ref="platformWidget" 
        placement="top" 
        trigger="click"
        :hide-on-click="false" 
        @visible-change="handleChangeVisible">
        <span class="el-dropdown-title wy-disable-select">
          <div class="header-title">
            Channel
          </div>
          <div class="button-container">
                <div class="el-dropdown-subtitle">
                <div class="platform-header">{{ platformHeader }}</div>
                <span class="platform-count">{{ platformCount }}</span>
                </div>
              <i v-bind:class="{'el-icon-caret-right':!isSelected, 'angle-up':isSelected }" ></i>
          </div>
        </span>
        <el-dropdown-menu id="wyPlatformPanel" class="wy-header-menu-panel wy-header-menu-platforms-panel" slot="dropdown" :class="{'has-brand': showBrands, 'no-date-range-layout': isDateRageHidden}">
          <!-- <transition name="bounce"> -->
            <div class="menu-panel">
              <div class="panel-column platform-panel">
                <!-- <div class="panel-header isBlue">{{ $t('menu.platformFilter.platform') }}</div> -->
                <div class="title-header" style="margin: 0px 0px;" @click="closePopup">Select channels:</div>
                <el-checkbox-group v-model="dataModel.filters.custTypes.value">
                  <!-- <el-checkbox v-for="platform in platforms" :label="platform.key" :key="platform.key" @change="checkboxChange(platform)">{{platform.label}}</el-checkbox> -->
                  <ul>
                    <li v-for="platform in dataModel.filters.custTypes.dataSource"  :key="platform.key" class="platform-name">
                      <el-checkbox :label="platform.key" @change="checkboxChange(platform)">{{platform.label}}</el-checkbox>
                      <span class="checkedIcon"></span>
                    </li>
                  </ul>
                </el-checkbox-group>
                <a @click="closePopup()" class="cancel-btn prevent-select">Cancel</a>
              </div>
              <el-button class="wy-white-button platform-apply" ref="dateApplyBtn" size="mini" @click="handleApply()">{{ $t('button.apply') }}</el-button>
            </div>
           <!-- </transition> -->
        </el-dropdown-menu>
      </el-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import WyFilter from '../../library/wy-filter';

export default {
  name: 'wy-header-menu-platform',
  data() {
    return {
      isSelected: false,
    }
  },

  computed: {
    ...mapGetters(['authUser', 'dataModel', 'moreFiltersCounter']),

    enableFilter() {
      let hasChanaged = this.$store.state.site.changed;
      if(hasChanaged) {
        return this.dataModel.hasFilter;
      }
      else {
        return false;
      }
    },

    selectedValues() {
      return this.dataModel.filters.custTypes.value;
    },

    isDateRageHidden() {
      let widget = this.$route.meta.headerMenuItems.find(el=>{
        return el.name == 'date-widget'
      })
  
      let isHidden = false;
      if((widget && widget.properties.hidden) || widget == undefined) {
        isHidden = true
      }
      return isHidden;
    },

    platformHeader() {
      let platformT = "Channels";
      let selecctedList = this.selectedValues.length > 0 ? this.selectedValues : [];
      if(this.dataModel.filters.custTypes.dataSource) {
        let platform = this.dataModel.filters.custTypes.dataSource.find(el => selecctedList.includes(el.key));
        if(platform) {
          platformT = platform.label;
        }
        else {
          platformT = 'None';
        }

        if(platformT.length > 50){
          platformT = platformT.substring(0, 50) + "...";
        }
      }

      if(this.dataModel.filters.custTypes && this.dataModel.filters.custTypes.dataSource && selecctedList.length == this.dataModel.filters.custTypes.dataSource.length) {
        platformT = 'All channels';
      }

      return platformT;
    },
    platformCount(){
      let selecctedList = this.selectedValues.length > 0 ? this.selectedValues : [];
      let platformC = '';

      if(this.dataModel.filters.custTypes && this.dataModel.filters.custTypes.dataSource && selecctedList.length == this.dataModel.filters.custTypes.dataSource.length) return

      if(this.dataModel.filters.custTypes && this.dataModel.filters.custTypes.dataSource) {
        let platforms = this.dataModel.filters.custTypes.dataSource.filter(el => selecctedList.includes(el.key));
        platformC = platforms.length > 1 ? ' +' + (platforms.length - 1) : '';
      }

      return platformC;
    },

    showBrands () {
      return this.authUser && this.authUser.companyList && this.authUser.companyList.length > 1;
    }
  },

  methods: {
    ...mapActions(['applyFilterValue', 'undoFilterValue']),

    checkboxChange(item) {
      if(this.dataModel.filters.custTypes.value.length == 0) {
        this.dataModel.filters.custTypes.value.push(item.key)
      }
    },

    handleChangeVisible(isOpen) {
      if(isOpen){
        this.$refs.platformWidget.show();
        this.$refs.platformWidget.popperElm.style.transitionDelay = "0s";
        this.isSelected = true;
        const eventInfo = {
          filter_group_name: 'Channel'
        }
        this.$router.logAmplitudeEvent({eventName: "GlobalFilter_Opened", eventInfo});
      }
      else {
        this.$refs.platformWidget.hide();
        this.$refs.platformWidget.popperElm.style.transitionDelay = "0.1s";
        this.isSelected = false;
      }

      // fire global click overlay event to show the modal
      this.$root.$emit(`fire-app-clickOverlayModal-events`, {handleApply: this.handleApply, active: isOpen});
    },

    async handleApply() {
      if(await this.applyFilterValue(this.dataModel.filters.custTypes)) {      
        this.dataModel.appliedFiltersCounter = this.moreFiltersCounter;
        if(!WyFilter.compareValues(this.dataModel.filters.custTypes.value, this.dataModel.filters.custTypes.valueOrigin)) {
          this.dataModel.appliedFiltersCounter = this.dataModel.appliedFiltersCounter + 1;
        }
         // if(isFromApplyBtn) {
          const eventInfo = {
            filter_group_name: 'Channel'
          }
          this.$router.logAmplitudeEvent({eventName: "GlobalFilter_Applied", eventInfo});
        // }
        this.$root.fireEvent({name: 'handleFilterChange', type: 'Global Filter: Channel'});
        // this.$router.logAmplitudeEvent({eventName: "GlobalFilter_Channel_applied"});
      }
      this.handleChangeVisible(false);
    },

    closePopup() {
      this.undoFilterValue({name: 'custTypes'});
      this.handleChangeVisible(false);
    }
  },

  updated() {
    if(document.querySelector(".component.platform-dropdown-widget")) {
      if(!this.dataModel.hasFilter) {
        document.querySelector(".component.platform-dropdown-widget").style.display = 'none';
      }
      else {
        document.querySelector(".component.platform-dropdown-widget").style.display = 'inline-block';
      }
    }
  },

  mounted() {
    if(!this.dataModel.hasFilter) {
      document.querySelector(".component.platform-dropdown-widget").style.display = 'none';
    }
    else {
      document.querySelector(".component.platform-dropdown-widget").style.display = 'inline-block';
    }
  },
}
</script>

<style lang="scss">
  .wy-header-menu-platform.selected{
    .el-dropdown-subtitle{
      position: relative !important;
      bottom: 10px !important;
    }
  }
.wy-header-menu-platform{
  // padding-right: 20px;
  .el-checkbox__input.is-disabled.is-checked .angle-up {
    top: 6px !important;
  }
  .button-container{
    float: left;
    // width: 200px;
    width: fit-content;
    height: 32px;
    position: relative;
    // bottom: 47px;
    display: flex;
    /* padding-bottom: 24px; */
    align-items: flex-end;
  }
  .platform-header{
    width: fit-content;
    max-width: 101px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    bottom: 3px;
    height: fit-content;
  }
  .platform-count{
    position: relative;
    bottom: 6px;
    // left: 4px;
  }
  .el-dropdown-subtitle {
    display: inline-block;
    padding-right: 7px;
    width: fit-content;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    right: -24px;
    bottom: 10px;
  }

  .angle-up {
    background-image: var(--header-drop-down-arrow-up);
    background-repeat: no-repeat;
    background-color: transparent;
    border: none;
    padding: 0;
    top: 3px;
    position: relative;
    height: 31px;
    background-size: 10px;
    width: 12px;
    left: 43px;
    display: inline-block;
  }
}
.wy-header-menu-platforms-panel.no-date-range-layout{	
  left: 612px !important;
}

.wy-header-menu-panel.wy-header-menu-platforms-panel.has-brand {
  left: var( --site-top-menu-platforms-panel-left-show-brand) !important;
}
.wy-header-menu-panel.wy-header-menu-platforms-panel {
  // width: 200px;
  // width: fit-content;
  width: min-content;
  border-radius: 0px;
  width: 641px;
  // left: 922px!important;
  left: var(--site-top-menu-platforms-panel-left) !important;

  margin: 64px 0 0px 0 !important;
  overflow-x: hidden;
  overflow-y: hidden;
  // @media (max-width: 1854px) {
  @media (max-width: 1440px) {
    .wy-header-menu-panel {
      left: 299px !important;
    }
  }
  .cancel-btn{
    color: var(--top-menu-panel-global-filter-cancel-btn-color);
    width: 612px;
    height: 36px;
    text-align: start;
    padding: 20px 0px 0px 25px;
    position: relative;
    font-size: 14px;
    top: 59px;
    right: -3px;
    border-radius: 0px 0px 10px 10px;
    cursor: pointer;
  }
  .menu-panel {
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    -webkit-box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow) !important;
    box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow);
    border-radius: 0px 0px 5px 7px;
    background: var(--nav-top-menu-panel-background-color) 0% 0% no-repeat padding-box;
    padding: 0;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    margin-left: -1px;
    width: 33%;
    height: 395px;
    min-width: 639px;
    position: relative;
    left: 2px;
    // border-top: 1px solid #C9D3DA;
  }
  .wy-white-button.platform-apply {
    width: 104px;
    height: 30px;
    border-radius: 10px;
    border: 1px white solid;
    left: calc(100% - 761px);
    top: 343px;
    background-color: var(--top-menu-panel-global-filter-primary-btn-background-color) !important;
    box-shadow: var(--top-menu-panel-global-filter-primary-btn-box-shadow) !important;
    padding-top: 6px;
    font-size: 14px;
    border: 1px white solid;
    border-radius: 5px;
    color: var(--top-menu-panel-global-filter-primary-btn-text-color);
    font-size: 14px;
    align-content: center;
    font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    position: relative;
    
    &:hover{
      border: 1px var(--top-menu-panel-global-filter-primary-btn-hover-border-color) solid !important;
      background-color: var(--top-menu-panel-global-filter-primary-btn-hover-background-color) !important;
      border-radius: 5px;
      color: var(--top-menu-panel-global-filter-primary-btn-hover-text-color) !important;
      font-size: 14px;
      align-content: center;
      font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    }
    &:active {
      background-color: var(--top-menu-panel-global-filter-primary-btn-pressed-background-color) !important;
    }
    &:focus {
      border: 1px var(--top-menu-panel-global-filter-primary-btn-hover-border-color) solid !important;
      background-color: unset;
      border-radius: 5px;
      color: var(--top-menu-panel-global-filter-primary-btn-text-color) !important;
    }
    span {
      position: relative;
      top: 1px;
    }
  }

  .panel-column {
    display: inline-grid;
    // width: 36%;
    padding: 0px 15px 0px 0px;
    width: 97.5%;
    height: 320px;
    border-bottom: 1px var(--top-menu-panel-global-filter-divider-color) solid;
    .panel-header{
      font-size: 17px;
      font-weight: 500;
      padding-bottom: 15px; 
      color: var(--site-font-primary-color);        
    }
    .isBlue{
      color: #214586;
    }
    // .title-header {
    //   font-weight: 600;
    //   font-size: 14px;
    //   color: #214586;
    //   padding-bottom: 2px;
    // }
    .title-header {
      font-weight: var(--top-menu-panel-global-filter-header-text-font-weight);
      font-size: var(--top-menu-panel-global-filter-header-text-font-size);
      color: var(--top-menu-panel-global-filter-header-text-color);
      padding: 15px 20px 0px 20px;
      line-height: 5px;
      top: 8px;
      left: 2px;
      position: relative;
    }
  }
  .el-checkbox-group {
    height: 251px;
  }
  div.el-checkbox-group label.el-checkbox {
    display: block;
    line-height: 36px;
    color: #F4F6F8;
    position: relative;
    left: -9px;
    height: 33px;
    padding-left: 14px !important;
    margin-top: 20px;
    padding-bottom: -3px;
    .el-checkbox__label {
      display: inline-block;
      font-size: 14px;
      font-weight: 500;
      color: var(--top-menu-panel-global-filter-checkbox-text-color);
    }
    span.el-checkbox__inner {
      border-radius: 0px;
      background-color: var(--top-menu-panel-global-filter-checkbox-button-background-color);
      color: var(--top-menu-panel-global-filter-checkbox-button-check-color);
      border: 1px solid var(--top-menu-panel-global-filter-checkbox-button-border-color) !important;
      top: 0px !important;
      width: 12px !important;
      height: 12px !important;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      // background-color: #020E14;
      background-color: var(--top-menu-panel-global-filter-checkbox-text-selected-background-color);
      border-radius: 0px;
    }
    .el-checkbox__inner::after {
      border: 1px solid var(--top-menu-panel-global-filter-checkbox-button-check-color);
      border-left: 0;
      border-top: 0;
      width: 2px !important;
    }
    span.el-checkbox__inner:hover {
      -webkit-box-shadow: unset;
      box-shadow: unset;
    }
  }
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: var(--top-menu-panel-global-filter-checkbox-text-checked-color);
  }
  .el-checkbox-group .is-disabled {
    opacity: 1;
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #214586;
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #FFF;
  }

  ul {
    padding-left: 0px;
    height: 270px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .platform-name.selected {
    border: 0.5px solid #FFFFFF;
    box-sizing: border-box;
    border-radius: 3px;
    width: 243px;
    .checkedIcon{
      background-image: url('../../assets/icons/icon_white_check.svg');
      background-repeat: no-repeat;
      background-size: 15px 15px;
      background-position-x: 3px;
      background-position-y: 8px;
      width: 20px;
      height: 30px;
      vertical-align: middle;
      float: right;
    }
  }
  .platform-name {
    color: #F4F6F8;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    border: 0.5px transparent solid;
    list-style: none;
    position: relative;
    right: 5px;
    top: 18px;
    height: 24px;
    margin: 0px 18px 8px 18px;
    margin-bottom: 16px;
    width: 276px;
    line-height: 30px;
    padding: 0px 0px 12px 15px;
  }
  .platform-name:focus, .brand-name:hover {
    background-color: rgba(229, 234, 242, 0.09);
    .checkedIcon{
      color: #EBF4FD;
    }
    color: #F4F6F8;
  }
}
.wy-header-menu-platform.selected {
  background: var(--nav-top-background-color-selected) 0% 0% no-repeat padding-box !important;
  position: relative;
  z-index: 9999;
}

.wy-header-menu-platform {
  &:hover{
    // background: rgba(229, 234, 242, 0.09) !important;
  }
  width: fit-content;
  height: 74px !important;
  .wy-header-manu-dropdown{
    margin: 0px 0px 0px 0px !important;
    padding: 14px 0px 0 0px !important;
    border-radius: 5px !important;
    opacity: 1 !important;
    height: 74px;
    // top: -14px !important;

    .el-dropdown-title {      
      white-space: nowrap;
    }
    
  }
  .wy-header-manu-dropdown.el-dropdown:hover {
    background-color: none !important;
  }
}
</style>